import {
  DOUGS_PARTNER_DISPLAY_NAME,
  DOUGS_PARTNER_IDENTIFIERS,
} from '@repo/company-creation-kit/common/constants/dougs';

export function isDougsCobrandingEnabled(partnerName: string | undefined) {
  if (!partnerName) {
    return false;
  }
  return DOUGS_PARTNER_IDENTIFIERS.includes(partnerName.toLowerCase());
}

export function getDougsDisplayName(partnerName: string | undefined): string | undefined {
  if (isDougsCobrandingEnabled(partnerName)) {
    return DOUGS_PARTNER_DISPLAY_NAME;
  }
  return undefined;
}
